export const APP_NAME = 'Vintegras';

export const API_BASE_URL = 'http://194.33.12.28:9998/';

export const ENDPOINTS = {
  GET_SERVER_TIME: API_BASE_URL + '/moment',
  LOGIN: API_BASE_URL + 'auth/login',
  PUT_ADMIN_PASSWORD: API_BASE_URL + 'api/v1/admin/password',
  GET_CURRENT_USER: API_BASE_URL + 'api/v1/current_user',
  GET_BUSINESS_OWNERS: API_BASE_URL + 'api/v1/business_owners',
  PUT_BUSINESS_OWNER_PASSWORD: API_BASE_URL + 'api/v1/business_owners/:ownerId/password',
  GET_COMPANIES: API_BASE_URL + 'api/v1/companies',
  POST_COMPANY: API_BASE_URL + 'api/v1/companies',
  POST_BUSINESS_OWNER: API_BASE_URL + 'api/v1/business_owners',
  DELETE_BUSINESS_OWNER: API_BASE_URL + 'api/v1/business_owners/:ownerId',
  DELETE_COMPANY: API_BASE_URL + 'api/v1/companies/:id',
  UPDATE_COMPANY: API_BASE_URL + 'api/v1/companies/:id',
  UPDATE_BUSINESS_OWNER: API_BASE_URL + 'api/v1/business_owners/:ownerId',
  ADD_CHANNEL: API_BASE_URL + 'api/v1/companies/:companyId/channels',
  GET_CHANNELS: API_BASE_URL + 'api/v1/companies/:companyId/channels',
  DELETE_CHANNEL: API_BASE_URL + 'api/v1/companies/:companyId/channels/:id',
  GET_USERS: API_BASE_URL + 'api/v1/companies/:companyId/users',
  POST_USER: API_BASE_URL + 'api/v1/companies/:companyId/users',
  UPDATE_USER: API_BASE_URL + 'api/v1/companies/:companyId/users/:userId',
  DELETE_USER: API_BASE_URL + 'api/v1/companies/:companyId/users/:userId',
  CHANNEL_ACCESS: API_BASE_URL + 'api/v1/channel_access',
  ASSETS: API_BASE_URL + 'api/v1/companies/:companyId/assets',
  DOWNLOAD_ASSET: API_BASE_URL + 'api/v1/companies/:companyId/assets/:assetId/download',
  DELETE_ASSET: API_BASE_URL + 'api/v1/companies/:companyId/assets/:assetId',
  PLAYLIST: API_BASE_URL + 'api/v1/companies/:companyId/playlists',
  PLAYLIST_ASSET: API_BASE_URL + 'api/v1/playlist_assets',
  DEVICES: API_BASE_URL + 'api/v1/companies/:companyId/devices',
  COPY_PLAYLIST: API_BASE_URL + 'api/v1/companies/:companyId/playlists/:playlistId/copy',
  UPDATE_PLAYLIST: API_BASE_URL + 'api/v1/companies/:companyId/playlists/:playlistId',
  DEVICE_ACTION: API_BASE_URL + 'api/v1/companies/:companyId/devices/action',
  DASHBOARD_PLAYLISTS: API_BASE_URL + 'api/v1/companies/:companyId/dashboard/playlists',
  DASHBOARD_DEVICES: API_BASE_URL + 'api/v1/companies/:companyId/dashboard/devices',
  DASHBOARD_DEPRECATED: API_BASE_URL + 'api/v1/companies/:companyId/dashboard/deprecated',
  PIN_TOKEN: API_BASE_URL + 'configure',
  CALENDAR: API_BASE_URL + 'api/v1/companies/:companyId/calendar/:channelId',
  VERSION: API_BASE_URL + 'updates',
  GET_NEWS_ALL : API_BASE_URL + 'api/v1/news',
  POST_NEWS: API_BASE_URL + 'api/v1/news',
  GET_NEWS_EXTERNAL_ALL : API_BASE_URL + 'api/v1/news/external',
  DELETE_NEWS : API_BASE_URL + 'api/v1/news/:newsId',
  GET_NEWS_BYID : API_BASE_URL + 'api/v1/news/:newsId',
  PUT_NEWS : API_BASE_URL + 'api/v1/news/:newsId',
  POST_BUS: API_BASE_URL + 'api/v1/bus_stations',
  GET_BUS_SYNC_ALL : API_BASE_URL + 'api/v1/bus_stations/sync',
  GET_BUS_ALL : API_BASE_URL + 'api/v1/bus_stations',
  DELETE_BUS : API_BASE_URL + 'api/v1/bus_stations/:busId',
  UPDATE_BUS : API_BASE_URL + 'api/v1/bus_stations/:busId',
  GET_EINKDEVICE_ALL : API_BASE_URL + 'api/v1/eink_devices',
  UPDATE_EINKDEVICE : API_BASE_URL + 'api/v1/eink_devices/:deviceId',
  GET_EINKDEVICE_UPDATEURLS : API_BASE_URL + '/api/v1/eink_devices/update_urls',
  GET_TIMETABLE : API_BASE_URL + 'timetables'
};

export const USER_ROLES = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  BUSINESS_OWNER: 'BUSINESS_OWNER',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  COMPANY_EDITOR: 'COMPANY_EDITOR',
  COMPANY_VIEWER: 'COMPANY_VIEWER',
  LPP_EDITOR: 'LPP_EDITOR'
};

export const USER_ROLES_TRANSLATIONS = {
  ADMINISTRATOR: 'Administrator',
  BUSINESS_OWNER: 'Lastnik',
  COMPANY_ADMIN: 'Podjetje',
  COMPANY_EDITOR: 'Urednik',
  COMPANY_VIEWER: 'Uporabnik',
  LPP_EDITOR: 'LPP_Urednik'
};

export const ACCESSIBLE_CHANNEL_TYPE = 'User';
export const ACCESSIBLE_CHANNEL_TYPE_DEVICE = 'Device';
export const ACCESSIBLE_CHANNEL_TYPE_PLAYLIST = 'Playlist';

export const DEVICE_ACTIONS = {
  STAND_BY: 'standby_on',
  STAND_BY_OFF: 'standby_off',
  RESTART_CLIENT: 'restart_client',
  RESTART_COMPUTER: 'restart_computer'
};

export const PLAYLIST_COLORS_BY_PRIORITY = {
  0: '#BA2A26',
  1: '#B94524',
  2: '#B96023',
  3: '#B97C21',
  4: '#B99920',
  5: '#B9B61E',
  6: '#9EB91D',
  7: '#80B91C',
  8: '#61B91A',
  9: '#41B919',
  10: '#21B917'
};



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.config.ts